import React from 'react'
import {ReactComponent as LeftArrowIcon} from '@Assets/icons/left-arrow.svg'
import { useHistory } from "react-router-dom";

import './index.scss'

interface iProps {
    title: string;
    theme?: string;
}

export const Navegation = function (props: iProps) {
    const history = useHistory();
    return (
        <div className="c_navegation">
            <LeftArrowIcon className={`c_navegation__icon ${props.theme}`} onClick={()=>{history.goBack();}}/>
            <h2 className={`c_navegation__title ${props.theme} e-text-black`}>{props.title}</h2>
        </div>
    )
}